import { TApplicationState } from '../../types/redux';

export function getNewbuildingBrokerBookingAvailable(state: TApplicationState) {
  return Boolean(state.newbuilding.isNewbuildingBrokerBookingAvailable);
}
